import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Websocket from './providers/Websocket';
import { PromoProvider } from './providers/Init';
import ThreeDSRoutes from './providers/3ds/ThreeDSRoutes';
import Quiz from './pages/Quiz';
import CheckoutFlow from './pages/CheckoutFlow';
import Final from './pages/Final';

function App() {
  return (
    <Router>
      <PromoProvider>
        <Websocket />
        <Routes>
          <Route path="/" element={<Quiz />} />
          <Route path="/checkout" element={<CheckoutFlow />} />
          <Route path="/final" element={<Final />} />
          <Route path="/success" element={<Final />} />
          <Route path="/ThankYou" element={<Final />} />
          {ThreeDSRoutes()}
        </Routes>
      </PromoProvider>
    </Router>
  );
}

export default App;

